import React from "react";
import {makeStyles} from "@mui/styles";
import {Box, Link} from "@mui/material";

const useStyles = makeStyles(() => ({
    authWrapper: {
        marginBottom: "24px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",

        // "& span, a": {
        //     fontSize: "12px",
        //     fontStyle: "normal",
        //     lineHeight: "22px",
        //     letterSpacing: "0em",
        // },

        // "& a": {
        //     color: "#2D40C5",
        // },

        // "& a:nth-of-type(1), a:nth-of-type(2)": {
        //     fontStyle: "normal",
        //     fontWeight: 900,
        //     lineHeight: "22px",
        //     letterSpacing: "0em",
        // }
    },
    link: {
        "&.MuiTypography-root": {
            color: "#828282",
            fontSize: "14px",
            lineHeight: "16px",
            textDecorationColor: "#828282"
        }
    }
}));

const AuthPrivacy = () => {
    const classes = useStyles();
    return (
        <Box className={classes.authWrapper}>
            <Link href="https://xcircular.com/privacy-policy-2/" target="privacyPolice" className={classes.link}>Privacy
                Policy </Link>
            <Link href="https://xcircular.com/terms-of-service/" target="TermOfService" className={classes.link}>Terms &
                Conditions</Link>
        </Box>
    );
}

export default AuthPrivacy;